import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

export default function Playbooks() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/playbooks").then(({ data }) => setItems(data)).catch(() => {});
  }, []);

  return (
    <div data-testid="playbooks-page" className="px-6 md:px-14 py-16 md:py-24">
      <div className="max-w-6xl">
        <div className="text-overline mb-4">◢ Use-case playbooks</div>
        <h1 className="font-display font-bold tracking-tighter text-4xl sm:text-5xl lg:text-6xl text-white leading-[1]">
          Built for the work, <span className="text-[#FF4500]">not</span> the title.
        </h1>
        <p className="mt-5 text-[#8E8E93] max-w-2xl text-[15px]">
          Each playbook is an operational area, not an industry vertical — because that's how plants
          actually run.
        </p>
      </div>

      <div className="mt-14 grid grid-cols-1 lg:grid-cols-2 gap-6">
        {items.map((p) => (
          <article key={p.id} data-testid={`playbook-${p.id}`} className="ww-card p-8">
            <div className="text-overline mb-3">{p.overline}</div>
            <h3 className="font-display text-3xl text-white">{p.title}</h3>

            <div className="mt-6 grid grid-cols-2 gap-6">
              <Section title="Challenges"        items={p.challenges} />
              <Section title="Typical workflows" items={p.workflows} />
              <Section title="What you build"    items={p.you_build} />
              <Section title="Example outcomes"  items={p.outcomes} accent />
            </div>
          </article>
        ))}
      </div>

      <div className="mt-14">
        <Link to="/contact" className="btn-primary">Pick a playbook →</Link>
      </div>
    </div>
  );
}

function Section({ title, items, accent }) {
  return (
    <div>
      <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-[#8E8E93] mb-2">{title}</div>
      <ul className="space-y-1.5">
        {(items || []).map((it) => (
          <li key={it} className={`text-sm flex items-start gap-2 ${accent ? "text-white" : "text-[#D7D7D9]"}`}>
            <span className="w-1 h-1 rounded-full mt-2 flex-shrink-0" style={{ background: accent ? "#DFFF00" : "#FF4500" }} />
            <span>{it}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
